export default __webpack_public_path__ + "static/media/Foto-21.ac430545.png";